"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function () {
  return {
    sideBar: {
      maxWidth: 500,
      width: '40%'
    }
  };
});
exports.default = useStyles;